<div class="depense">
  <div class="depense__header">
    <button (click)="openModalDepenses()" class="q-btn q-main mt-2">
      <i class="fas fa-tasks mr-2"></i>Sélectionner les dépenses
    </button>
    <button (click)="openModalDelete()" [disabled]="!deleteDisable" class="q-btn q-c-danger"><i class="fa-solid fa-trash-can"></i></button>
  </div>
  <div class="depense__body">
    <q-customgrid #grid
                  *ngIf="gridReload"
                  [customgridName]="'PageDepenseAg'"
                  [idDonnee]="service.Stage.Ident"
                  (cellValueChanged)="cellValueChanged($event)"
                  (selectChanged)="selectChanged($event)">
    </q-customgrid>
  </div>
</div>


<ng-template #modal let-modal>
  <div class="modal-header">
    <h5 class="q-c-main q-bold">Sélection des dépenses</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-modal p-0">

      <div class="depense-type-header">
        <div>
          <button *ngIf="!adminDepenseType" (click)="createDepenses()" class="q-btn q-main"><i class="fa-solid fa-floppy-disk mr-2"></i>Ajouter</button>
        </div>

        <button title="administration" class="btn-no-background" (click)="openDepenseTypeAdministration()" [ngClass]="{'btn-no-background--toggle':adminDepenseType}">
          <i class="fa-solid fa-gears"></i>
        </button>
      </div>

      <table class="depense-table" *ngIf="!adminDepenseType; else tplAdminDepenseType">
        <thead>
          <tr>
            <th></th>
            <th>Libellé</th>
            <th>Commentaire</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let depense of depensesType;let index = index">
            <td class="depense-table__column--small">
              <div class="q-check">
                <input type="checkbox" id="task-{{index}}" [(ngModel)]="depense.IsSelected" />
                <label for="task-{{index}}">
                  <span></span>
                </label>
              </div>
            </td>
            <td>{{depense.Info_BOV}}</td>
            <td> <input type="text" [(ngModel)]="depense.commentaire" /> </td>
            <td><input type="text" [(ngModel)]="depense.montant" /></td>
          </tr>
        </tbody>
      </table>
      <ng-template #tplAdminDepenseType>
        <q-adminpropdata [options]="propOption"></q-adminpropdata>
      </ng-template>
    </div>
  </div>
</ng-template>


<ng-template #modalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement les dépenses associées ?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="deleteSelectedValue();modal.dismiss()"
              title="Supprimer la tâche">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>


<!--#region modal BO GRID-->
<ng-template #modalBo let-modalBo class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">{{boModel.Title}}</h5>
      <button type="button" class="close" (click)="modalBo.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <q-bodisplay [globalsave]="false" [item]="boModel" (sendEvent)="reloadGrid()"></q-bodisplay>
    </div>
  </div>
</ng-template>
<!--#endregion modal BO GRID -->
